import DropdownField from '../../../../../../../../elements/DropdownField'
import { useState, useEffect } from 'react'
import Radio from '../../../../../../../../elements/form/Radio'
import styles from './styles.module.scss'
import { useSearchContext } from '../../../../../../../../../providers/SearchContext'
import IconBedroom from '/public/icons/icon-bedroom.svg'
import { useRouter } from 'next/router'

const Bedrooms = ({
  form: { setFieldValue },
  variant,
  width,
  property,
  translations,
  ...props
}) => {
  const [value, setValue] = useState('')
  const { bedroomOptions, setBedroomOptions, guests } = useSearchContext()
  const [close, setClose] = useState(false)
  const router = useRouter()

  useEffect(() => {
    setBedroomOptions('')
  }, [])

  useEffect(() => {
    setValue(bedroomOptions)
    setFieldValue('bedrooms', bedroomOptions)
  }, [bedroomOptions])

  useEffect(() => {
    if (bedroomOptions && Number(bedroomOptions?.split(' ')[0]) * 2 < guests) {
      setValue([])
      setBedroomOptions('')
      setFieldValue('bedrooms', [])
    }
  }, [guests])

  useEffect(() => {
    setClose(true)

    setTimeout(() => setClose(false), 100)
  }, [bedroomOptions])

  const handleChange = (e) => {
    setBedroomOptions && setBedroomOptions(e.target.value)
  }

  return (
    <DropdownField
      {...props}
      prependIcon={<IconBedroom width={40} height={28} />}
      isActive={value.length !== 0}
      variant={[...variant, 'right']}
      triggerClose={close}
      disabled={!property.is_active}
      value={
        value.length !== 0
          ? `${translations.beds[router.locale]} ${value}`
          : translations?.bedrooms[router.locale]
      }
    >
      <div style={{ width: width }} className={styles.radios}>
        <div>
          {property?.bedroom_option &&
            property?.bedroom_option?.map((item, index) => (
              <Radio
                key={index}
                name="bedrooms"
                value={item?.room_title}
                label={item?.room_title}
                checked={
                  !(Number(item.room_title?.split(' ')[0]) * 2 < guests) &&
                  item?.room_title === bedroomOptions
                }
                disabled={Number(item.room_title?.split(' ')[0]) * 2 < guests}
                onChange={(e) => handleChange(e)}
              />
            ))}
        </div>
      </div>
    </DropdownField>
  )
}

export default Bedrooms
